import React from 'react';
import "../../styles/header.css"

const currentYear = new Date().getFullYear();

export const FooterComponent = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <p>Secretaría de Protección Civil {currentYear}</p>  
        {/* <p>
          <a 
            href='https://www.veracruz.gob.mx/proteccioncivil/avisos-de-privacidad/' 
            target='_blank'
            rel="noopener noreferrer"
            className="footer-link"
          >
            Aviso de Privacidad
          </a>
        </p> */}
        |
        <p>
          <a 
            href='/login' 
            target='_parent'
            rel="noopener noreferrer"
            className="footer-link"
          >
            Acceso
          </a>
        </p>
      </div>
    </footer>
  );
};

export default FooterComponent;